jQuery(document).ready(function ($) {
	$(".aj-modal").each(function () {
		const modal = new AJ_Modal(this);
	});
});

function AJ_Modal(_obj) {
	this.delay = 5000;
	this.obj = _obj;
	this.active_class = "active";
	this.ls_id = $(this.obj).data("ls-id") ? $(this.obj).data("ls-id") : "aj_modal";
	this.init();
}

AJ_Modal.prototype.init = function () {
	var me = this;
	$(this.obj)
		.find('[data-js="modal-close"]')
		.on("click", function () {
			me.close();
		});

	me.checkOpen();
};

AJ_Modal.prototype.checkOpen = function () {
	if ($(".aj-bloque-newsletter").length > 0) {
		return;
	}
	if (localStorage.getItem(this.ls_id) === null) {
		setTimeout(() => {
			this.open();
		}, this.delay);
	}
};

AJ_Modal.prototype.open = function () {
	$(this.obj).addClass(this.active_class);
};

AJ_Modal.prototype.close = function () {
	$(this.obj).removeClass(this.active_class);
	localStorage.setItem(this.ls_id, "true");
};
